import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import setupAxiosInterceptor from './services/axios-interceptor';

setupAxiosInterceptor();

createApp(App).use(router).mount('#app');
